export const SET_PRACTISE_CONVERSATION_DATA = 'SET_PRACTISE_CONVERSATION_DATA'
export const SET_PRACTISE_SESSION_ID = 'SET_PRACTISE_SESSION_ID'
export const SET_PRACTISE_USER_RESUME_ID = 'SET_PRACTISE_USER_RESUME_ID'
export const SET_PRACTISE_USER_RESUME_METADATA = 'SET_PRACTISE_USER_RESUME_METADATA'
export const SET_PRACTISE_USER_JD_ID = 'SET_PRACTISE_USER_JD_ID'
export const SET_PRACTISE_USER_JD_METADATA = 'SET_PRACTISE_USER_JD_METADATA'
export const SET_PRACTISE_PREFERENCES = 'SET_PRACTISE_PREFERENCES'
